import store from '../../store'

export function updateWhiteboardSetting(setting,value) {	
	store.dispatch({ type:'UPDATE_WHITEBOARD_SETTING',setting,value})
}
